import Login from '@components/Auth/Login';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { routes } from '@routes';
import { useSession } from '@hooks';

type LoginPageProps = {
    //
};


const languagesVarsCodes = [
    "LANG_neobooking_auth_to_log_in", //Se connecter
    "LANG_neobooking_auth_to_log_in_intro", //Connectez-vous pour accéder à votre espace client
    "LANG_neobooking_auth_register_now", //créer un compte
    "LANG_neobooking_or", //ou
]

const LoginPage: React.FC<LoginPageProps> = () => {

    const { getLanguageVarValue } = useSession()

    return <>
        <div className='tw-container sm:tw-mx-auto sm:tw-w-full sm:tw-max-w-2xl'>
            <h1 className="title">{getLanguageVarValue("LANG_neobooking_auth_to_log_in")}</h1>
            <p>{getLanguageVarValue("LANG_neobooking_auth_to_log_in_intro")}
                <br /> {getLanguageVarValue("LANG_neobooking_or")} {" "}
                <NavLink to={routes.register} className="focus:tw-outline-none tw-cursor-pointer tw-text-primary-500 hover:tw-text-primary-400 tw-transition-colors tw-duration-200 tw-ease-in-out">
                    {getLanguageVarValue("LANG_neobooking_auth_register_now")}{" "}!
                </NavLink>
            </p>
            <Login />
        </div>
    </>
}

export default LoginPage;